<template>
    <div class="alm-chevron-wrapper">
        <f-icon icon="chevronright" class="clickable" :class="{ 'is-expanded': isExpanded }" @click="toggle($event)" />
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Localizer } from "@/api/Localizer";

export default defineComponent({
    props: {
        params: Object,
    },
    data() {
        return {
            localizer: new Localizer(this.$store),
            isExpanded: false,
        };
    },
    beforeMount() {
        if (this.params && this.params?.node) {
            this.isExpanded = this.params.node.expanded;
        } else {
            this.isExpanded = false;
        }
    },
    methods: {
        toggle(event: MouseEvent) {
            event.stopPropagation();
            if (this.params && this.params?.node) {
                this.isExpanded = !this.isExpanded;
                const node = this.params.node;
                node.setExpanded(!node.expanded);
            }
        },
    },
});
</script>

<style>
.alm-chevron-wrapper {
    height: 100%;
}
.alm-chevron-wrapper .clickable {
    cursor: pointer;
}
.alm-chevron-wrapper .is-expanded {
    transform: rotate(90deg);
}
</style>
